<template lang="pug">
  .content
    .content__block.content-contacts
      div.content-contacts__item(
      v-for="item in campData.contacts"
      )
        p
          span.camp-content__subtitle(
          v-if="item.present_post.length > 0"
          ) {{item.present_post}}:&#32;
          span.camp-content__text {{item.fio}}
        p
          span.camp-content__subtitle Телефон:&#32;
          span.camp-content__text {{item.extra}}
      div.content-contacts__item(
        v-if="socialNetworks.length > 0"
      )
        social-networks-list(
        :links="socialNetworks"
        )

</template>

<script>

import SocialNetworksList from "../../../../../components/socialNetworksList/SocialNetworksList";
export default {
  name: "CampContacts",
  components: {SocialNetworksList},
  props: {
    campData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    socialNetworks() {
      const arr = [];
      if (this.campData && this.campData.vkontakte.length > 0) {
        arr.push({
          url: this.campData.vkontakte,
          icon: require("@/assets/images/icons/vk.svg")
        });
      }
      if (this.campData && this.campData.instagram.length > 0) {
        arr.push({
          url: this.campData.instagram,
          icon: require("@/assets/images/icons/inst.svg")
        });
      }
      return arr;
    }
  }

};
</script>
